import AppEnv from "./AppEnv.js";


// local
const siteConfigLocal = {
    assetBaseUrl: "https://cognitva-website-assets.s3.ap-south-1.amazonaws.com",
    apiBaseUrl: "http://localhost:8000"
}


// prod
const siteConfigProd = {
    assetBaseUrl: "https://cognitva-website-assets.s3.ap-south-1.amazonaws.com",
    apiBaseUrl: "https://api.cognitva.ai"
}

const siteConfig = AppEnv.isProduction ? siteConfigProd : siteConfigLocal;

export default siteConfig;